import dateFns from 'date-fns';
import { isNil } from 'lodash';

export const convertDate = date => {
  if (isNil(date)) return '';
  return dateFns.format(new Date(date), 'MM/DD/YYYY');
};

//@Param date- String of UTC Type
export const formatUTCDate = (dateString,format='MM/dd/yyyy') => {
  if (isNil(dateString)) return '';
  const { DateTime } = require('luxon');
  return DateTime.fromISO(dateString, { zone: 'utc' }).toFormat(format);
};

// gets the current date in the format MM/DD/YYYY
//@param: Date
export const transformDate = (date) => {
  date = new Date(date);
  var year = date.getFullYear();
  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : '0' + month;
  var day = date.getDate().toString();
  day = day.length > 1 ? day : '0' + day;
  return month + '/' + day + '/' + year;
}

//@Param date- String of EST Type
export const formatUSLocaleDate = (
  dateString = "",
  format = "MM/dd/yyyy"
) => {
  if (isNil(dateString)) return "";
  const { DateTime } = require("luxon");
  if (dateString.includes("-")) {
    return DateTime.fromISO(dateString, { zone: "America/New_York" }).toFormat(
      format
    );
  } else {
    return DateTime.fromJSDate(new Date(dateString), {
      zone: "America/New_York",
    }).toFormat(format);
  }
};

export const convertDateForNotes = date => {
  if (isNil(date)) return '';
  return dateFns.format(new Date(date), 'MMM D, YYYY');
};

export const convertIntoMonthYear = date => {
  let month = new Date(date).getMonth();
  let year = new Date(date).getFullYear();
  return { month: month, year: year };
};

export const compareDates = (firstDate, secondDate) => {
  if (isNil(firstDate) || isNil(secondDate)) return 0;
  return dateFns.compareAsc(new Date(firstDate).setHours(0, 0, 0, 0), new Date(secondDate).setHours(0, 0, 0, 0));
};

export const getTimeString = (hours, mins) => {
  if (isNil(hours) || isNil(mins)) return 0;
  const today = new Date();
  return dateFns.format(new Date(today.getFullYear(), today.getMonth(), today.getDate(), hours, mins, 0, 0), 'hh:mm A');
};

export const convertDateFormat = (date, format = 'MM/DD/YY') => {
  if (isNil(date)) return '';
  return dateFns.format(new Date(date), format);
};

export const distanceInDays = (date1, date2) => {
  if (isNil(date1) || isNil(date2)) return '';
  return dateFns.distanceInWordsStrict(date1, date2, { unit: 'd', roundingMethod: 'ceil' });
};

export const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate();

export const addMonthsToDate = (inputDate, noOfMonths) => {
  const dateObj = new Date(inputDate);
  dateObj.setDate(1);
  dateObj.setMonth(dateObj.getMonth() + noOfMonths);
  dateObj.setDate(Math.min(inputDate.getDate(), getDaysInMonth(dateObj.getFullYear(), dateObj.getMonth() + 1)));
  return dateObj;
}
export const getPastDateFromDays = (days) => {
  return new Date(new Date().setDate(new Date().getDate() - days));
}
export const getFutureDateFromDays = (days, date = null) => {
  if (!isNil(date)) {
    return new Date(new Date(date).setDate(new Date(date).getDate() + days));
  } else {
    return new Date(new Date().setDate(new Date().getDate() + days));
  }
}

//@param: datesList - list of dates string in format 'MM/DD/YYYY'
export const getMinDate = (datesList) =>{
  if(datesList?.length > 0){
      datesList = datesList.map(x => new Date(x));
      return convertDate (Math.min.apply(null, datesList));
  }
  return null;
}

//@param: datesList - list of dates string in format 'MM/DD/YYYY'
export const getMaxDate = (datesList) =>{
  if(datesList?.length > 0){
      datesList = datesList.map(x => new Date(x));
      return convertDate (Math.max.apply(null, datesList));
  }
  return null;
}
export const formatMMDDYYYY_HHMM = (isoString) => {
  if (!isoString) return '';
  
  const d = new Date(isoString); 
  const mm = String(d.getMonth() + 1).padStart(2, '0'); 
  const dd = String(d.getDate()).padStart(2, '0');      
  const yyyy = d.getFullYear();                          
  const HH = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0'); 

  return `${mm}/${dd}/${yyyy} ${HH}:${min}`;
};

